import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0f160020")
const _hoisted_1 = { class: "p-d-flex p-jc-center p-ai-center h100 position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "🧠", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ProgressSpinner, {
      style: {"width":"50px","height":"50px"},
      strokeWidth: "5",
      fill: _ctx.CSSColors.Gray400,
      animationDuration: "1s"
    }, null, 8, ["fill"]),
    _hoisted_2
  ]))
}